/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pos_Create_Delivery_OrderInputs */

const vi_pos_create_delivery_order = /** @type {(inputs: Pos_Create_Delivery_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tạo đơn giao`)
};

/**

* @param {Pos_Create_Delivery_OrderInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pos_create_delivery_order = /** @type {((inputs?: Pos_Create_Delivery_OrderInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pos_Create_Delivery_OrderInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pos_create_delivery_order(inputs)
});